import {$qs, $qsAll} from '../../@shared/ts/dom';
import {type WCPHPData} from '../../@type/woocommerce/php-data';
import {peachpay_addCustomMerchantStyles, peachpay_hideLoadingSpinner, shouldLoadButtonBasedOnAccountSettings, peachpay_initButton, update_buttonIcon} from './button';
import {peachpayButtonTemplate} from './templates/button';

declare const peachpay_data: WCPHPData;

/**
 * Entry point for cart-page.js
 */
document.addEventListener('DOMContentLoaded', () => {
	if (!peachpay_data.is_cart_page) {
		return;
	}

	// Use set interval to support the maximum number of themes
	setInterval(() => {
		peachpay_maybeRenderButtonCartPage();
	}, 250);
});

function peachpay_maybeRenderButtonCartPage() {
	const $button = document.querySelector('#pp-button-container:not(.pp-float-container)');
	if (!$button) {
		// Remove any existing .pp-break elements so we do not clutter up the DOM if any are present
		$qsAll<HTMLElement>('.wc-proceed-to-checkout .pp-break', $el => {
			$el.remove();
		});

		peachpay_renderButtonCartPage();
	}
}

// Renders the peachpay button in the cart page
function peachpay_renderButtonCartPage() {
	peachpay_insertButtonCartPage();
	peachpay_addCustomMerchantStyles();

	if ($qs('#button-icon-regular')) {
		update_buttonIcon(peachpay_data.button_icon, 'regular');
	}
}

function peachpay_insertButtonCartPage() {
	const selector = peachpay_data.custom_button_placement.cart_page;
	const $wcButtonContainer = selector ? $qs(selector) : $qs('.wc-proceed-to-checkout');

	if ($wcButtonContainer) {
		peachpay_insertButtonAt($wcButtonContainer, 'beforeend');
		return;
	}

	const $wpBlocksButton = $qs('.wc-block-cart__payment-options');
	if ($wpBlocksButton) {
		peachpay_insertButtonAt($wpBlocksButton, 'afterbegin');
	}
}

function peachpay_insertButtonAt($element: HTMLElement, location: InsertPosition) {
	if (!peachpay_data.is_cart_page || peachpay_data.cart_page_hide) {
		return;
	}

	if (!shouldLoadButtonBasedOnAccountSettings()) {
		return;
	}

	const full = peachpay_data.button_alignment_cart_page === 'full' || !peachpay_data.button_alignment_cart_page;
	const width = full ? '100%' : ((peachpay_data.button_width_cart_page || '220') + 'px');

	$element.insertAdjacentHTML(location, peachpayButtonTemplate());

	// We must do this because we changed the <img> tags to <object> tags to
	// fix a Safari issue where it would not load animated SVGs. If we have
	// the hide class on the element right away, the SVG is not loaded, so the
	// first time you click the button it's not there. Only after it is visible
	// does it load, so we allow it to be visible for a split second before
	// hiding it here.
	peachpay_hideLoadingSpinner();

	peachpay_initButton({
		width,
		alignment: peachpay_data.button_alignment_cart_page,
		borderRadius: peachpay_data.button_border_radius,
	});
}
